import type { IRecordTypeDefinition, IRecordTypeOverride } from '@platform/core/types';
import { ApiError } from './ApiError';
import type { HttpClient } from './HttpClient';
import type { IRecordTypeOverrideDoc } from './IRecordTypeOverrideDoc';

const path = (ws: string, rt: string) => `/workspaces/${ws}/record-types/${encodeURIComponent(rt)}/override`;

/**
 * Перевизначення типів записів простору (ADR-023): читання (404 — ще немає: порожній патч, версія 0), збереження з If-Match версії
 * (відповідь — злитий тип запису; застаріла версія — 412) і повернення до опублікованого визначення.
 */
export class OverrideDao {
  constructor(private readonly http: HttpClient) {}

  async get(ws: string, rt: string): Promise<IRecordTypeOverrideDoc> {
    try {
      return await this.http.get<IRecordTypeOverrideDoc>(path(ws, rt));
    } catch (e) {
      if (e instanceof ApiError && e.status === 404) return { patch: {}, version: 0 };
      throw e;
    }
  }
  save(ws: string, rt: string, patch: IRecordTypeOverride, version: number): Promise<IRecordTypeDefinition> {
    return this.http.put(path(ws, rt), { patch }, version);
  }
  reset(ws: string, rt: string): Promise<void> { return this.http.delete(path(ws, rt)); }
}
